class CookieConsent extends HTMLElement {
	constructor() {
		super();  

        this.cookie = this;

		var hasConsent = this.getCookie('cookie-consent') !== '';
		try {
			if (!hasConsent && window.localStorage && window.localStorage.getItem('cookie-consent')) {
				hasConsent = true;
			}
		} catch (e) {}

		if (!hasConsent){
            this.cookie.style.display = "block";

			if(this.cookie.classList.contains('full-width')){
                var cookieHeight = this.cookie.offsetHeight;

                if(cookieHeight > 0){
                    document.body.style.paddingBottom = cookieHeight + "px";
                }

                var w = window.innerWidth;

                window.addEventListener('resize', () => {
                    if (window.innerWidth == w) {
                        return
                    }

                    w = window.innerWidth;

                    var cookieHeight = this.cookie.offsetHeight;

                    if(cookieHeight > 0){
                        document.body.style.paddingBottom = cookieHeight + "px";
                    }
                });
            }
		} else {
			this.remove();
		}

		this.querySelector('[data-accept-cookie]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
	}

	setCookie(cname, cvalue, exdays) {
  		const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(event, expiresDate = 365) {
        event.preventDefault();
        
        this.setCookie('cookie-consent', 'closed', expiresDate);
        try {
            if (window.localStorage) {
                window.localStorage.setItem('cookie-consent', 'closed');
            }
        } catch (e) {}
        document.dispatchEvent(new Event('revent:cookie-consent'));

        this.cookie.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        this.cookie.style.opacity = '0';
        this.cookie.style.transform = 'translateY(16px)';
        
        var self = this;
        setTimeout(function() {
            self.cookie.remove();
            if(self.cookie.classList.contains('full-width')){
                document.body.style.paddingBottom = "0px";
            }
        }, 260);
    }
}

customElements.define('cookie-consent', CookieConsent);
